import { Badge } from './Badge';
import { InvoiceStatus } from '@aelita/shared';

type InvoiceStatusValue = (typeof InvoiceStatus)[keyof typeof InvoiceStatus];
type BadgeVariant = 'gray' | 'primary' | 'green' | 'yellow' | 'red' | 'blue' | 'purple';

const STATUS_CONFIG: Record<InvoiceStatusValue, { label: string; variant: BadgeVariant }> = {
  [InvoiceStatus.DRAFT]: { label: 'Draft', variant: 'gray' },
  [InvoiceStatus.SENT]: { label: 'Sent', variant: 'blue' },
  [InvoiceStatus.PAID]: { label: 'Paid', variant: 'green' },
  [InvoiceStatus.EXPIRED]: { label: 'Expired', variant: 'yellow' },
  [InvoiceStatus.VOID]: { label: 'Void', variant: 'red' },
};

interface InvoiceStatusBadgeProps {
  status: string;
}

export function InvoiceStatusBadge({ status }: InvoiceStatusBadgeProps) {
  const config = STATUS_CONFIG[status as InvoiceStatusValue] ?? {
    label: status,
    variant: 'gray' as BadgeVariant,
  };
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
